// Core
import {authconfig} from './authconfig';
import {coreconfig} from './coreconfig';

// App
import {mainconfig} from './mainconfig';
import {financeconfig } from './financeconfig';
import {budgetconfig } from './budgetconfig';
import {formsconfig } from './formsconfig';
import {activityconfig} from './activityconfig';
import {kpisconfig} from './kpisconfig';
import {filesconfig } from './filesconfig';

// Tools
import {reportconfig} from './reportconfig';
import {uploadconfig} from './uploadconfig';
import {apisconfig } from './apisconfig';
import {uiuxconfig} from './uiuxconfig';

export const serviceconfig = {
  ...authconfig,
  ...coreconfig,
  
  ...mainconfig,
  ...financeconfig,
  ...budgetconfig,
  ...formsconfig,
  ...activityconfig,
  ...kpisconfig,
  ...filesconfig,

  ...reportconfig,
  ...uploadconfig,
  ...apisconfig,
  ...uiuxconfig,
};
